import { Button } from "@tql/ui-components-react/tql/buttons";

type ActionButtonsRowProps = {
	readonly isSaving?: boolean;
	readonly onSaveAddress: () => void;
};

export function ActionButtonsRow({
	isSaving = false,
	onSaveAddress,
}: ActionButtonsRowProps) {
	return (
		<div className={"save-address"}>
			<Button disabled={isSaving} onClick={onSaveAddress} tabIndex={-1}>
				{isSaving ? "Saving Address..." : "Save Address"}
			</Button>
		</div>
	);
}
